import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=47b488ed&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b488ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b488ed')) {
      api.createRecord('47b488ed', component.options)
    } else {
      api.reload('47b488ed', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=47b488ed&scoped=true&", function () {
      api.rerender('47b488ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2t2IY3FDbFOJC/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports